// Immutable get/set for dot-paths with numeric array indices ("list.0.t").
export function getPath(obj, path) {
  if (!path) return obj;
  const parts = String(path).split(".");
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

export function setPath(obj, path, value) {
  const parts = String(path).split(".");
  const clone = Array.isArray(obj) ? obj.slice() : { ...(obj || {}) };
  let cur = clone;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    const next = cur[p];
    const nextIsArray = /^\d+$/.test(parts[i + 1]);
    cur[p] = Array.isArray(next)
      ? next.slice()
      : next && typeof next === "object"
      ? { ...next }
      : nextIsArray
      ? []
      : {};
    cur = cur[p];
  }
  cur[parts[parts.length - 1]] = value;
  return clone;
}
